import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function RequireAdmin({ children }) {
  const [state, setState] = useState("checking"); // checking | ok | denied
  const navigate = useNavigate();
  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setState("ok"); return; }
    api.get("/auth/me", { withCredentials: true })
      .then(() => setState("ok"))
      .catch((e) => {
        setState("denied");
        if (e?.response?.data?.detail === "MFA required") {
          navigate(`/admin/mfa/verify?next=${encodeURIComponent(window.location.pathname)}`, { replace: true });
        } else {
          navigate("/admin/login", { replace: true });
        }
      });
  }, [navigate]);
  if (state === "checking") return <div className="pt-32 text-center"><Loader2 className="w-8 h-8 text-amber-600 mx-auto animate-spin" /></div>;
  if (state !== "ok") return null;
  return children;
}
